import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sparkles, Zap, ShieldCheck, Star } from 'lucide-react';
import { Button } from './ui/Button';
interface HeroProps {
  onCheckout: () => void;
}
export function Hero({
  onCheckout
}: HeroProps) {
  return <section className="relative bg-white pt-6 pb-12 md:pt-12 md:pb-16 overflow-hidden" data-id="element-136">
      <div className="max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 relative z-10" data-id="element-137">
        <div className="text-center max-w-4xl mx-auto" data-id="element-138">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brown/5 border border-brown/10 text-brown font-medium text-[10px] sm:text-sm uppercase tracking-wider mb-5" data-id="element-139">
            <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold" data-id="element-140" />
            Biblioteca digital espiritual
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-[28px] sm:text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-black leading-[1.1] mb-6" data-id="element-141">
            La biblioteca holística{' '}
            <span className="text-terracotta italic" data-id="element-142">más completa</span> en un
            solo lugar
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="relative max-w-md mx-auto mb-6" data-id="element-143">
            <div className="absolute inset-0 bg-gold/10 blur-3xl rounded-full transform -translate-y-1/4" data-id="element-144" />
            <img src="https://cdn.magicpatterns.com/uploads/aV2QUzQXjB5PHWTtyCHUiR/8CFFA9E8-1089-4FAF-BD32-49FC63D98624_(1).webp" alt="Pack Holístico Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-145" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-base md:text-lg text-gray-600 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-146">
            +70 libros, cursos y manuales digitales sobre tarot, reiki,
            registros akáshicos, constelaciones, chakras, péndulo, feng shui,
            biodecodificación y mucho más.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex flex-wrap justify-center gap-2 md:gap-6 mb-8" data-id="element-147">
            {[{
            icon: BookOpen,
            text: '+70 recursos digitales'
          }, {
            icon: Sparkles,
            text: '+55 disciplinas'
          }, {
            icon: Zap,
            text: 'Acceso inmediato'
          }, {
            icon: ShieldCheck,
            text: 'Pagás una vez y es tuyo para siempre'
          }].map((item, i) => <div key={i} className="flex items-center gap-1.5 text-xs md:text-base font-medium text-gray-800" data-id="element-148">
                <item.icon className="w-4 h-4 md:w-5 md:h-5 text-terracotta" data-id="element-149" />
                <span data-id="element-150">{item.text}</span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-gray-50 border border-gray-100 rounded-2xl p-4 md:p-6 max-w-2xl mx-auto mb-6 shadow-sm" data-id="element-151">
            <div className="text-[11px] md:text-sm font-bold text-terracotta uppercase tracking-[0.2em] mb-3" data-id="element-152">
              Oferta especial por tiempo limitado
            </div>
            <div className="flex items-baseline justify-center gap-2 md:gap-3 mb-4 tabular-nums" data-id="element-153">
              <span className="text-base md:text-lg text-gray-400 line-through font-medium tracking-tight" data-id="element-154">
                $50.000
              </span>
              <span className="text-4xl md:text-5xl font-bold text-black tracking-tight" data-id="element-155">
                $17.990
              </span>
              <span className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-156">
                ARS
              </span>
            </div>

            <Button onClick={onCheckout} fullWidth className="md:text-lg py-4" data-id="element-157">
              SÍ, QUIERO MI PACK AHORA
            </Button>

            <div className="mt-3 flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500 font-medium" data-id="element-158">
              <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-159" />
              <span data-id="element-160">
                Compra segura · Descarga inmediata · Compatible con celular y PC
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7
        }} className="flex items-center justify-center gap-3" data-id="element-161">
            <div className="flex -space-x-2" data-id="element-162">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center overflow-hidden" data-id="element-163">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-164" />
                </div>)}
            </div>
            <div className="flex flex-col items-start" data-id="element-165">
              <div className="flex text-gold" data-id="element-166">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current" data-id="element-167" />)}
              </div>
              <span className="text-xs font-medium text-gray-600" data-id="element-168">
                +500 personas ya transformaron su camino espiritual
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}